import workspaceQuery from '../../../graphql/queries/customer/CustomerGlobalAmendResultsWorkspaceQuery.graphql';
import instanceQuery from '../../../graphql/queries/customer/CustomerGlobalAmendQuery.graphql';
import { EntityType } from '../../../@types/entityTypes';

const CustomerGlobalAmendResult: EntityType = {
  type: 'CustomerGlobalAmendResult',
  title: 'Customer Global Amendment Results',
  formTitle: 'Customer Global Amendment Result',
  formUrl: undefined,
  workspaceUrl: '/Customers/CustomerGlobalAmendResultDetails/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  screenReference: 'CUSTOMERS_GLOBAL_AMENDMENTS',
};

export default CustomerGlobalAmendResult;
